import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  TooltipProps,
  CartesianGrid,
} from "recharts";

interface BarChartComponentProps {
  data: {
    year: string;
    monthName: string;
    monthNumber: number;
    openActions: number;
    closedActions: number;
  }[];
}

const CustomTooltip: React.FC<TooltipProps<number, string>> = ({
  active,
  payload,
  label,
}) => {
  if (active && payload && payload.length) {
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "#fff",
          padding: "10px",
          border: "1px solid #ccc",
          fontSize: "10px",
        }}
      >
        <p className="label" style={{ margin: 0 }}>{`${label}`}</p>
        {payload.map((entry, index) => (
          <p
            key={index}
            style={{ margin: 0, color: entry.color }}
          >{`${entry.name}: ${entry.value}`}</p>
        ))}
      </div>
    );
  }

  return null;
};

const allMonths = [
  { monthName: "Jan", monthNumber: 1 },
  { monthName: "Feb", monthNumber: 2 },
  { monthName: "Mar", monthNumber: 3 },
  { monthName: "Apr", monthNumber: 4 },
  { monthName: "May", monthNumber: 5 },
  { monthName: "Jun", monthNumber: 6 },
  { monthName: "Jul", monthNumber: 7 },
  { monthName: "Aug", monthNumber: 8 },
  { monthName: "Sep", monthNumber: 9 },
  { monthName: "Oct", monthNumber: 10 },
  { monthName: "Nov", monthNumber: 11 },
  { monthName: "Dec", monthNumber: 12 },
];

const BarChartComponent: React.FC<BarChartComponentProps> = ({ data }) => {
  const mergedData = allMonths.map((month) => {
    const monthData = data.find((d) => d.monthNumber === month.monthNumber);
    return monthData
      ? monthData
      : { ...month, openActions: 0, closedActions: 0 };
  });

  mergedData.sort((a, b) => a.monthNumber - b.monthNumber);

  return (
    <ResponsiveContainer width="100%" height={258}>
      <BarChart data={mergedData}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="monthName" />
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Legend />

        {/* Bars for openActions and closedActions */}
        <Bar
          dataKey="openActions"
          fill="#216ba5"
          name="Open Actions"
          radius={[10, 10, 0, 0]}
        />
        <Bar
          dataKey="closedActions"
          fill="#82ca9d"
          name="Closed Actions"
          radius={[10, 10, 0, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarChartComponent;
